module.exports = __webpack_public_path__ + "summernote.6887f295e5fd80996fbd.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/summernote/0.8.9/font/summernote.ttf?e557617934c52ea068954af79ed7c221
// module id = 1259
// module chunks = 8